import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from "redux-persist";

import { persistedReducer } from "./rootReducer";
import { middleware } from "./utils";

import "./middleware";

export const store = configureStore({
  devTools: import.meta.env.MODE !== "production",
  reducer: persistedReducer,
  middleware: (gdm) =>
    gdm({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(middleware)
});
export const persistor = persistStore(store);

setupListeners(store.dispatch);
